<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import ArrowLeft from '@primeicons/vue/arrow-left';
import type { V2ShipmentDetail } from '@gpx-spa/queries/src/getAccountShipmentV2';
import TopMapToolbar from '@/components/_common/navbar/TopMapToolbar.vue';
import ShipmentStatusBadge from '@/components/shipment/shared/ShipmentStatusBadge.vue';

const props = defineProps<{
  shipment?: V2ShipmentDetail | null;
}>();

const router = useRouter();
const store = useStore();

const shipmentName = computed(() => props.shipment?.name?.trim() || 'Shipment');

function goBack() {
  router.push({
    name: 'ShipmentListView',
    query: { search: store.getters['shipment/search'] },
  });
}
</script>

<template>
  <div class="w-full border-b border-neutral-200 bg-white">
    <TopMapToolbar>
      <template #start>
        <div class="flex min-w-0 flex-1 items-center gap-3">
          <button
            type="button"
            class="-ml-1 shrink-0 rounded-md p-1 text-neutral-400 transition-colors hover:bg-neutral-100 hover:text-neutral-600"
            aria-label="Back to shipments"
            @click="goBack"
          >
            <ArrowLeft :size="20" class="text-current" aria-hidden="true" />
          </button>
          <template v-if="shipment">
            <span class="h-4 w-px shrink-0 bg-neutral-300" aria-hidden="true" />
            <h1 class="min-w-0 truncate text-base font-semibold text-neutral-900">
              {{ shipmentName }}
            </h1>
            <ShipmentStatusBadge
              v-if="shipment.status"
              :status="shipment.status"
              class="shrink-0"
            />
          </template>
        </div>
      </template>
    </TopMapToolbar>
  </div>
</template>
